import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  Output,
  ViewEncapsulation,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { PlaceType } from '../place.category/customize.place.category.component';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { clone, isEmptyObject } from '../../../common/extensions';
import {
  CustomDefaultPlaceCategoryItemEditedStore,
  CustomDefaultPlaceCategoryItemSelectionStore,
} from '../../../stores/hub.calendar.store';
import { PlaceService } from '../../../services/place.service';
import { ShowInfoModalComponent } from '../show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../show.info.modal/show.info.modal.provider';
import { ModalService } from '../../../common/services/modal.service';
import { config } from '../../../../config/config';
import { routeConfigs } from '../../../common/constants/route.config';
import { AlertifyService } from '../../../services/alertify.service';
import { CategoryChangeData } from '../../../commands/pagination.query.command';
import { ConfigService } from '../../../services/config.service';
import { DropEvent } from 'ng-drag-drop';
import { ShowCategoryLinkModalComponent } from '../show.category.link.modal/show.category.link.modal.component';
import {
  CategoryLinkModalData,
  ShowCategoryLinkModalActions,
} from '../show.category.link.modal/show.category.link.modal.provider';

@Component({
  selector: 'ig-accordion-editor',
  templateUrl: './accordion.editor.component.html',
  styleUrls: ['./accordion.editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccordionEditorComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public tempTitle: string;
  public isUseDefault = true;
  public form: FormGroup;
  public isExpanded = false;

  @ViewChild('accordion') accordion: AccordionComponent;
  @ViewChildren('categoryItem') categoryItems: QueryList<ElementRef>;
  @ViewChildren('subaccordion') accordions: QueryList<ElementRef>;

  @Input() public item: PlaceType;
  @Input() public parent: PlaceType;
  @Input() public isSelected = false;
  @Input() public isEditMode = true;
  @Input() public maxLevels = 3;

  @Output() onCategoryClick: EventEmitter<PlaceType> = new EventEmitter<PlaceType>();
  @Output() onSubCategoryAdded: EventEmitter<PlaceType> = new EventEmitter<PlaceType>();
  @Output() onRemoved: EventEmitter<PlaceType> = new EventEmitter<PlaceType>();
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private alertify: AlertifyService,
    private modalService: ModalService,
    private customDefaultPlaceCategoryItemSelectionStore: CustomDefaultPlaceCategoryItemSelectionStore,
    private customDefaultPlaceCategoryItemEditedStore: CustomDefaultPlaceCategoryItemEditedStore
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.tempTitle = clone(this.item.title);

    this.form = this.formBuilder.group({
      categoryName: [null, []],
    });

    this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.takeUntil(
      this.isDestroyed
    ).subscribe((data: PlaceType) => {
      if (data && data.id) {
        this.isSelected = this.item.id === data.id;
      } else {
        this.isSelected = false;
      }
    });
  }

  public changeUseDefault() {}

  public expandCategory() {}

  public toggle(isExpanded: boolean) {
    this.isExpanded = isExpanded;
    this.onToggle.emit(isExpanded);
  }

  public setCategories(item: PlaceType) {
    this.onCategoryClick.emit(item);
    // for changing selection style
    this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next(item);
  }

  public syncCategoryListAreaHeightWithEditorAreaHeight() {
    setTimeout(() => {
      const editorArea = document.getElementById('editor-area');
      const categoryListArea = document.getElementById('sub-category-wrap');
      if (!editorArea || !categoryListArea) return;

      const rect = editorArea.getBoundingClientRect();
      categoryListArea.style.height = `${rect.height - 16}px`;
    });
  }

  public dragEnter($event) {
    if ($event && $event.currentTarget) {
      this.restoreItemStyle();
      $event.currentTarget.style.outline = '2px dashed orange';
    }
  }

  private restoreItemStyle() {
    this.accordions.toArray().forEach((x) => {
      x.nativeElement.style.outline = 'none';
    });
  }

  public onItemDrop(e: DropEvent, targetIndex: number, parent: PlaceType) {
    console.log({ e });
    console.log({ targetIndex });
    const dragItemIndex = parent.subCategories.indexOf(e.dragData as PlaceType);
    console.log({ dragItemIndex });

    // swap items
    [parent.subCategories[targetIndex], parent.subCategories[dragItemIndex]] = [
      parent.subCategories[dragItemIndex],
      parent.subCategories[targetIndex],
    ];

    setTimeout(() => {
      this.restoreItemStyle();
    });
  }

  public showURL() {
    if (!this.item['_id']) {
      // this is just created, id not set
      this.alertify.warning(
        'Please save the whole custom category settings and refresh your browser to getting the link'
      );
      return;
    }

    const placeCalendarPath = routeConfigs.visitor.placeCalendar.path;
    const place = `${placeCalendarPath.substr(0, placeCalendarPath.indexOf('/:'))}`;
    const link = this.getPlaceWidgetUrlEmbedScript(place, this.item['_id']);
    const jsonApi = `${ConfigService.config.apiAddress}v2.0/${this.hubName}/${place}?custom_category=${this.item['_id']}`;

    this.modalService.show({
      component: ShowCategoryLinkModalComponent,
      providers: [
        { provide: ShowCategoryLinkModalActions, useValue: null },
        { provide: CategoryLinkModalData, useValue: new CategoryLinkModalData(link, jsonApi) },
      ],
      panelClass: 'width-modal-4',
    });
  }

  public addSubCategory() {
    this.item.subCategories.push(new PlaceType(!this.parent ? '2nd level' : '3rd level', this.item.level + 1));
    setTimeout(() => {
      this.accordion && this.accordion.open();
      this.onSubCategoryAdded.emit(this.item);
    });
  }

  public removeSubCategory() {
    // not 1st level
    if (this.parent) {
      this.parent.subCategories = this.parent.subCategories.filter((x) => x.id !== this.item.id);
    }

    this.onRemoved.emit(this.item);

    // CustomizePlaceCategoryComponent will take care of the data to send to server side to remove the category from places
    this.customDefaultPlaceCategoryItemEditedStore.customDefaultPlaceCategoryItemEditedCommand.next({
      type: 'deleted',
      item: this.item,
    } as CategoryChangeData);
  }

  public enterEditMode(item: PlaceType) {
    item.isEditing = true;
    this.setCategories(item);
  }

  public updateCategoryTitle() {
    if (!/^[a-zA-Z0-9- ]+$/.test(this.tempTitle)) {
      this.alertify.warning('Category title can only contain letters, numbers and hyphens');
      return;
    }
    /**
     *   remove the category code same with the old name
     * */
    const code = PlaceService.toCategoryCode(this.item.title);
    if (this.item.categoryList.indexOf(code) >= 0) {
      this.item.categoryList = this.item.categoryList.filter((x) => x !== code);
    }

    const oldTitle = clone(this.item.title);
    this.item.title = clone(this.tempTitle);
    this.item.isEditing = false;

    /** after edited a category, need to notify the server side to update the existing places which hold this category. Subscribe in CustomizePlaceCategoryComponent */
    this.customDefaultPlaceCategoryItemEditedStore.customDefaultPlaceCategoryItemEditedCommand.next({
      type: 'edited',
      item: this.item,
      oldTitle,
      newTitle: this.item.title,
    } as CategoryChangeData);
  }

  public cancelUpdateTitle() {
    this.tempTitle = clone(this.item.title);
    this.item.isEditing = false;
  }

  public canAddSub() {
    return this.item.level < this.maxLevels - 1;
  }

  public clearFilter() {
    this.accordion && this.accordion.clearFilter(null, false);
  }

  private getPlaceWidgetUrlEmbedScript(place: string, placeId: any) {
    return `<div id="imgoingcalendar-wrapper" route="/${this.hubName}/${place}/${placeId}/custom" url-change="true">
             <app-root></app-root>
            <script type="text/javascript" src="https://imgoingcalendar.com/imgoingscript.js"></script>
        </div>`;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/accordion.editor/accordion.editor.component.ts